import { makeKey, update } from "../../../../utils/reducerOperations";
export function resetPasswordStarted(state, payload) {
  return makeKey(
    "resetPasswordApi",
    update(state.resetPasswordApi, { isProcessing: true })
  );
}
